export const saveExportTaskCompleteMutation = `mutation SaveExportTaskComplete($input: ExportTaskCompleteInput!) {
    saveExportTaskComplete(input: $input) {
        status
        details
        error {
            message
            date
        }
    }
}`;